<template>
    <div class="relative min-h-screen">
        <div class="center-object absolute w-full">
            <div>
                <span class="animated fadeIn delay-1s lg:text-10xl text-7xl sm:text-8xl md:text-9xl font-bold flex justify-center text-center leading-none">Move<br>Heroes</span>
                <MainMenuSubTitle class="animated fadeIn delay-1s" />
                <Start
                  v-if="user.loggedIn"
                  question="0"
                  class="animated fadeIn delay-2s"
                 />
                 <SignIn
                  @openModal="show( $event )"
                  class="animated fadeIn delay-2s"
                  v-else
                  />
            </div>
        </div>
        <modal
          :adaptive="adapt"
          height="auto" :minHeight="300" name="login">
          <LoginForm
           @closeModal="hide( $event )"
          />
        </modal>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Start from "@/components/content/buttons/Start.vue"
import LoginForm from "@/components/Login.vue"
import SignIn from "@/components/content/buttons/SignIn.vue"
import MainMenuSubTitle from "@/components/content/title/subtitle/MainMenuSubTitle.vue"

export default {
    data() {
      return {
        adapt: true
      }
    },
    components: {
        LoginForm,
        Start,
        SignIn,
        MainMenuSubTitle
    },
    computed: {
      ...mapState({
        user: "user"
      })
    },
    methods: {
      show () {
        this.$modal.show('login');
      },
      hide () {
        this.$modal.hide('login');
      }
    }
}
</script>
